export default function InformationPopup(props) {
    return <div className={"modal information-popup"}>{typeof props.content !== "undefined" ? props.content : ""}</div>;
}
